import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { AuthResponse } from '../../models/auth-response.model';
import { AuthService } from '../../services/auth.service';
import { SidenavService } from '../../services/sidenav.service';
import { SnackbarService } from '../../services/snackbar.service';
import { UsersService } from '../../services/users.service';
import { ConfirmModalComponent } from '../shared/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  standalone: false,
})
export class UsersComponent implements OnInit {
  sidenav: MatSidenav;
  users: any[];
  searchQuery = '';
  paymentFilter: 'all' | 'paid' | 'unpaid' = 'all';

  constructor(
    private sidenavService: SidenavService,
    private usersService: UsersService,
    private authService: AuthService,
    private snackbar: SnackbarService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
  }

  async ngOnInit() {
    this.users = await this.usersService.getList();
  }

  get paidCount(): number {
    return this.users?.filter((u) => u.hasPaid).length ?? 0;
  }

  get filteredUsers(): any[] {
    const query = this.searchQuery.trim().toLowerCase();

    return (this.users ?? []).filter((user) => {
      const matchesPayment =
        this.paymentFilter === 'all' ||
        (this.paymentFilter === 'paid' && user.hasPaid === true) ||
        (this.paymentFilter === 'unpaid' && user.hasPaid !== true);
      const matchesSearch =
        !query || String(user.name ?? '').toLowerCase().includes(query);

      return matchesPayment && matchesSearch;
    });
  }

  setPaymentFilter(filter: 'all' | 'paid' | 'unpaid'): void {
    this.paymentFilter = filter;
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  goBack() {
    this.router.navigate(['/admin']);
  }

  editUser(user: any) {
    this.router.navigate([`/admin/users/${user._id}`]);
  }

  impersonate(user: any) {
    this.dialog
      .open(ConfirmModalComponent, {
        panelClass: 'confirm-dialog',
        data: {
          title: 'Suplantar participante',
          eyebrow: 'Sesión temporal',
          icon: 'switch_account',
          tone: 'highlight',
          message:
            `Vas a entrar en la aplicación como <strong>${user.name}</strong>. ` +
            'Podrás volver a tu cuenta de administrador desde la franja superior.',
          cancelText: 'Cancelar',
          confirmText: 'Entrar como participante',
        },
      })
      .afterClosed()
      .subscribe((confirmed) => {
        if (!confirmed) return;

        this.usersService
          .impersonate(user._id)
          .then(async (response: any) => {
            await this.authService.startImpersonation(
              response as AuthResponse,
            );
            this.router.navigate(['/home'], { replaceUrl: true });
          })
          .catch((error) => {
            this.snackbar.error(
              error?.message || 'No se pudo suplantar al participante.',
            );
          });
      });
  }

  togglePayment(user: any) {
    user.hasPaid = !user.hasPaid;
    this.usersService.update(user);
  }

  sendPaymentReminders() {
    this.usersService.sendPaymentReminders();
  }

  delete(user: any) {
    // Show confirmation modal and then execute api call
    this.dialog
      .open(ConfirmModalComponent, {
        data: {
          title: 'Elimninar usuario',
          message: '¿Estás seguro de que quieres eliminar este usuario?',
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.usersService.delete(user._id);
      });
  }
}
